<script>
	/*
		TCareRadioButton.svelte

		Contains the circle and the label.
	*/

	export let source;
	export let prop;
	export let setValue;
	export let value;
	export let label;

	// determined differently since question.value is an array
	// $: isSelected = source[prop] ? source[prop].includes(value) : false;
	$: isSelected = source[prop] === value;

	const _onClick = () => {
		if (!source[prop]) source[prop] = [];
		// setValue(source, prop, [value]);		// using array
		setValue(source, prop, value);		// not using array
	}
	
</script>

<style>
</style>

<div class="tcui-control flex-row radio-button" on:click={_onClick}>
	{#if isSelected}
		<div class="outer flex-center selected">
			<div class="inner"></div>
		</div>
	{:else}
		<div class="outer flex-center"></div>
	{/if}
	<div class="label">{label}</div>
</div>
